import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../components/ui/card";
import Spinner from "../../../components/ui/spinner";
import { getRevenue } from "../../../services/apiservices/support";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Bar,
  BarChart
} from "recharts";

const MonthlyRevenueGraphCard = ({ timeRange }) => {
  const [revenueData, setRevenueData] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setRevenueData();
    setLoading(true);
    getRevenue(timeRange, true).then((data) => {
      setRevenueData(data);
      setLoading(false);
    });
  }, [timeRange]);

  return (
    <Card className="bg-white dark:bg-[#2c3440] p-24">
      <CardHeader className="p-24">
        <CardTitle>Monthly Revenue</CardTitle>
      </CardHeader>
      <CardContent>
        {loading ? (
          <Spinner size="lg" />
        ) : (
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={revenueData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="revenue" fill="#82ca9d" />
            </BarChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
};

export default MonthlyRevenueGraphCard;
